import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Platform, View, StyleSheet , Text,SafeAreaView, ScrollView, FlatList, Button, Image,StatusBar, TouchableOpacity } from 'react-native';
import { useTailwind } from 'tailwind-rn';
import { useNavigation } from '@react-navigation/native';



const Header = (  ) => {

    const tailwind = useTailwind();
    const navigation = useNavigation();

    let GoHome = (object) => {
        console.log("Volver a recursos:");

        navigation.navigate("Principal", {  })
    }

    return (
        <View style={ tailwind("bg-gray-100 bg-pt-5 flex-row flex-wrap justify-evenly border-t-8 border-t-matcongreen") }>
            <Image
                source={ require('../assets/images/header/matcon-logo1.png') }
                style={ tailwind("h-32 w-32 bottom-1") }
                />
            <View style={ tailwind("md:flex-row flex-wrap m-justify-evenly content-center ") } >
                <TouchableOpacity  style={ tailwind("bg-transparent border-l-4 border-r-4 md:border-r-0 border-matconred") }
                     onPress={GoHome}
                >
                    <Text style={ tailwind("uppercase text-xl px-3 m-2 p4 text-matcondarkblue") }>Recursos</Text>
                </TouchableOpacity>
                <TouchableOpacity style={ tailwind("bg-transparent border-l-4 border-r-4 border-matconred") }>
                    <Text style={ tailwind("uppercase text-xl px-3 m-2 p4 text-matcondarkblue") }>Actividades</Text>
                </TouchableOpacity>
                <TouchableOpacity style={ tailwind("bg-transparent border-l-4 md:border-l-0 border-r-4 border-matconred") }>
                    <Text style={ tailwind("uppercase text-xl px-3 m-2 p4 text-matcondarkblue") }>Material</Text>
                </TouchableOpacity>
            </View>
        </View>
    );

}

export default Header